<template lang="html">
  <LegalDocumentLayout
    :title="item?.title || fallbackTitle"
    :source-key="hasCmsContent ? undefined : 'returns'"
  >
    <InfoCmsBody :item="item" :has-cms-content="hasCmsContent">
      <LegalDocumentBody :blocks="returnsPolicyBlocks" />
    </InfoCmsBody>
  </LegalDocumentLayout>
</template>

<script setup lang="ts">
import { brandInfo } from '#Brand/info'
import InfoCmsBody from '#Info/components/InfoCmsBody.vue'
import LegalDocumentBody from '#Info/components/LegalDocumentBody.vue'
import LegalDocumentLayout from '#Info/components/LegalDocumentLayout.vue'
import { useInfoCmsPage } from '#Info/composables/useInfoCmsPage'
import { infoCmsSlugs } from '#Info/constants/cmsPages'
import { returnsPolicyBlocks } from '#Info/content/returnsPolicy'

defineOptions({
  name: 'InfoReturnsPage',
})

const fallbackTitle = `Политика возвратов товара интернет-магазина ${brandInfo.name}`

const { item, hasCmsContent } = await useInfoCmsPage(infoCmsSlugs.returnsPolicy)

useContentSeo(item, { fallbackTitle })
</script>
